// extracted by mini-css-extract-plugin
export default {"termsText":"TermsAndConditions_termsText__sjUHj"};